module.exports = __webpack_public_path__ + "static/marketing-937f9eccf2bd2b6031342990ba1e9032.jpg";